import React, { useState } from 'react';
import { Button } from '../components/ui/Button';
import { Input } from '../components/ui/Input';
import { Table, Column } from '../components/ui/Table';
import { Plus, Search, BadgeCheck, Ban } from 'lucide-react';
import { FeeProfileForm } from '../components/FeeProfileForm';
interface Fee {
  id: string;
  code: string;
  name: string;
  feeClass: string;
  category: string;
  status: 'active' | 'inactive';
}
export function FeeSetup() {
  const [isCreating, setIsCreating] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  // Mock Data
  const fees: Fee[] = [{
    id: '1',
    code: 'FEE-001',
    name: 'Processing Fee',
    feeClass: 'Transaction Fees',
    category: 'Origination',
    status: 'active'
  }, {
    id: '2',
    code: 'FEE-002',
    name: 'Late Payment Fee',
    feeClass: 'Transaction Fees',
    category: 'Penalty',
    status: 'active'
  }, {
    id: '3',
    code: 'FEE-003',
    name: 'SMS Notification Fee',
    feeClass: 'Event Fees',
    category: 'Administrative',
    status: 'active'
  }, {
    id: '4',
    code: 'FEE-004',
    name: 'Annual Maintenance Fee',
    feeClass: 'Event Fees',
    category: 'Recurring',
    status: 'active'
  }, {
    id: '5',
    code: 'FEE-005',
    name: 'Document Fee',
    feeClass: 'Transaction Fees',
    category: 'Administrative',
    status: 'inactive'
  }];
  const filteredFees = fees.filter(f => f.name.toLowerCase().includes(searchQuery.toLowerCase()) || f.code.toLowerCase().includes(searchQuery.toLowerCase()) || f.category.toLowerCase().includes(searchQuery.toLowerCase()) || f.feeClass.toLowerCase().includes(searchQuery.toLowerCase()));
  const columns: Column<Fee>[] = [{
    key: 'code',
    label: 'Fee Code'
  }, {
    key: 'name',
    label: 'Fee Name',
    render: item => <span className="font-medium text-gray-900" data-id="element-2052">{item.name}</span>
  }, {
    key: 'feeClass',
    label: 'Fee Class',
    render: item => <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${item.feeClass === 'Transaction Fees' ? 'bg-purple-100 text-purple-800' : 'bg-orange-100 text-orange-800'}`} data-id="element-2053">
          {item.feeClass}
        </span>
  }, {
    key: 'category',
    label: 'Fee Category'
  }, {
    key: 'status',
    label: 'Status',
    render: item => <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${item.status === 'active' ? 'bg-green-100 text-green-800' : 'bg-gray-100 text-gray-800'}`} data-id="element-2054">
          {item.status === 'active' ? <BadgeCheck className="w-3 h-3 mr-1" data-id="element-2055" /> : <Ban className="w-3 h-3 mr-1" data-id="element-2056" />}
          {item.status.charAt(0).toUpperCase() + item.status.slice(1)}
        </span>
  }];
  if (isCreating) {
    return <FeeProfileForm onBack={() => setIsCreating(false)} onSave={() => {
      setIsCreating(false);
    }} data-id="element-2057" />;
  }
  return <div className="space-y-8 animate-in fade-in duration-500" data-id="element-2058">
      {/* Header */}
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4" data-id="element-2059">
        <div data-id="element-2060">
          <h1 className="text-2xl font-bold text-gray-900 tracking-tight" data-id="element-2061">
            Fee Setup
          </h1>
          <p className="text-gray-500 mt-1" data-id="element-2062">
            Configure fee structures and templates for loan products.
          </p>
        </div>
        <Button size="lg" className="shadow-sm" onClick={() => setIsCreating(true)} data-id="element-2063">
          <Plus className="mr-2 h-5 w-5" data-id="element-2064" />
          Add New Fee
        </Button>
      </div>

      {/* Search */}
      <div className="bg-white p-4 rounded-lg border border-gray-200 shadow-sm" data-id="element-2065">
        <div className="relative" data-id="element-2066">
          <Search className="absolute left-3 top-2.5 h-5 w-5 text-gray-400" data-id="element-2067" />
          <Input placeholder="Search fees by code, name, class, or category..." className="pl-10 border-0 bg-gray-50 focus:bg-white transition-colors" value={searchQuery} onChange={e => setSearchQuery(e.target.value)} data-id="element-2068" />
        </div>
      </div>

      {/* Table */}
      <Table columns={columns} data={filteredFees} onRowClick={fee => console.log('Clicked fee:', fee)} keyExtractor={item => item.id} data-id="element-2069" />
    </div>;
}